import { render, staticRenderFns } from "./goods-rank.vue?vue&type=template&id=48abe721&scoped=true&"
import script from "./goods-rank.vue?vue&type=script&lang=js&"
export * from "./goods-rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48abe721",
  null
  
)

export default component.exports